/**
 * Historia 161-serialize-concurrent-workflow-saves-to-stop-d (jupiter slice) — CU6/D3/RN19/V4.
 *
 * Sun serializes every save of a workflow's version series (RN1-RN14) and rejects a "save as new
 * version" (`PUT /workflow/true/...`) when the series already advanced past the version the save
 * started from (RN4). The rejection travels as HTTP 409 with the frozen literal
 * `WORKFLOW_VERSION_ALREADY_SAVED`, enriched with the vigent version to reload
 * (`03-dominio.md` §"Contrato cross-repo congelado"):
 *
 *   { "message": "WORKFLOW_VERSION_ALREADY_SAVED", "error": "WORKFLOW_VERSION_ALREADY_SAVED",
 *     "latestWorkflowId": 1008, "latestVersion": 9.0 }
 *
 * V4: the conflict is recognised by HTTP 409 AND the literal in `error` (or, failing that, in
 * `message` — the shape `Api_Functions` already gives every rejection). A 409 with any other
 * literal (e.g. the duplicated planning group conflict) keeps its current treatment untouched.
 */

export const WORKFLOW_VERSION_ALREADY_SAVED = 'WORKFLOW_VERSION_ALREADY_SAVED'

/**
 * @param {{status?: number, message?: string, data?: object}} thrown Error thrown by `Api_Functions`.
 * @returns {boolean} True when `thrown` is Sun's version-conflict rejection (V4).
 */
export const isWorkflowVersionConflict = (thrown) => {
  if (!thrown || thrown.status !== 409) {
    return false
  }
  const data = typeof thrown.data === 'object' && thrown.data !== null ? thrown.data : {}
  const literal = typeof data.error === 'string' && data.error !== '' ? data.error : thrown.message
  return literal === WORKFLOW_VERSION_ALREADY_SAVED
}

/**
 * @param {{status?: number, message?: string, data?: object}} thrown Error thrown by `Api_Functions`.
 * @returns {{isConflict: boolean, latestWorkflowId: number, latestVersion: number}} `isConflict`
 *   is false for anything that is not the version conflict (V4); `latestWorkflowId`/`latestVersion`
 *   default to `0` when the conflict is not recognised or the contract field is missing (DL5).
 */
export const readWorkflowVersionConflict = (thrown) => {
  const isConflict = isWorkflowVersionConflict(thrown)
  const data = isConflict && typeof thrown.data === 'object' && thrown.data !== null ? thrown.data : {}
  return {
    isConflict,
    latestWorkflowId: typeof data.latestWorkflowId === 'number' ? data.latestWorkflowId : 0,
    latestVersion: typeof data.latestVersion === 'number' ? data.latestVersion : 0
  }
}
